import { Component, AfterViewChecked, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-base',
    template: `NO UI TO BE FOUND HERE!`
})
export class BaseComponent implements AfterViewChecked, OnDestroy {
    public totalLazyAds: number = 0;
    //    public initializedLazyLoad: boolean = false;
    //    public adObserver: IntersectionObserver = null;

    constructor() {
    }

    public ngAfterViewChecked() {
        //        if (typeof window === 'undefined')
        //            return;
        //        this.loadLazyAds();
    }

    ngOnDestroy() {
        //        console.log("ngOnDestroy ");
    }
    /*
        public loadLazyAds() {
            if ("IntersectionObserver" in window) {
                let lazyAds = document.querySelectorAll(".lazy-adsense");
                if (!lazyAds || lazyAds.length === 0 || this.getAds() === 0) {
                    return;
                }
                if (lazyAds.length < this.getAds()) {
                    return;
                }
                if (this.initializedLazyLoad)
                    return;
                if (lazyAds.length == this.getAds())
                    this.initializedLazyLoad = true;
                console.log("loadLazyAds - initializing ads - lazyAds.length=" + lazyAds.length + " this.getAds()=" + this.getAds());
                //            var adObserver = new IntersectionObserver(function (entries, observer) {
                this.adObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            var ad = entry.target;
                            console.group("intersection happened " + JSON.stringify(ad));
    
                            ad.classList.remove("lazy-adsense");
                            this.adObserver.unobserve(ad);
    
                            const p: any = {};
                            p.google_ad_client = "ca-pub-8567476900751738";
                            try {
                                const adsbygoogle = (window as any).adsbygoogle;
                                console.log("pushing ad " + JSON.stringify(adsbygoogle));
                                adsbygoogle.push(p);
                                return true;
                            } catch (e) {
                                console.log("error pushing ad " + e.message);
                            }
    
                        }
                    });
                });
    
                lazyAds.forEach(image => {
                    console.group("adding observer " + JSON.stringify(image));
                    this.adObserver.observe(image);
                });
            }
        }
    */
    public getAds() {
        return this.totalLazyAds;
    }

    public pushAllAds(theNumberOfAds: number) {
        console.log("pushAllAds " + theNumberOfAds);
        this.totalLazyAds = theNumberOfAds;
    }

}